import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {getPoint} from "../../../pages/Giftbox/redux/actions";
import {getCoupon} from "../../../pages/Giftbox/redux/actions";

export const usePoint = () => {
  const dispatch = useDispatch();
  const { point,isProcessingPoint } = useSelector(state => state.giftboxReducers);

  useEffect(() => {
    dispatch(getPoint());
  }, [dispatch, getPoint]);

  return [point,isProcessingPoint]
};


export const useCoupon = () => {
  const dispatch = useDispatch();
  const { coupons, isProcessing } = useSelector(state => state.giftboxReducers);

  useEffect(() => {
    dispatch(getCoupon());
  }, [dispatch, getCoupon]);

  return [coupons, isProcessing]
};
